import * as React from "react";
const EmergencyResponseUnitIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M40.183 22.667h-.35v-2.5A4.167 4.167 0 0 0 35.667 16H31.5v-2.492A2.51 2.51 0 0 0 28.992 11H6.508A2.51 2.51 0 0 0 4 13.508v19.159h4.167a5 5 0 1 1 10 0h10a4.984 4.984 0 0 1 3.333-4.709 4.836 4.836 0 0 1 1.667-.291 5.004 5.004 0 0 1 5 5h4.558A1.27 1.27 0 0 0 44 31.392v-4.909a3.816 3.816 0 0 0-3.817-3.816ZM34.925 18.5a2.404 2.404 0 0 1 2.408 2.409v1.758H31.5V18.5h3.425ZM21.5 21h-1.667v1.667a1.68 1.68 0 0 1-1.666 1.666 1.671 1.671 0 0 1-1.667-1.666V21h-1.667a1.68 1.68 0 0 1-1.666-1.666 1.672 1.672 0 0 1 1.666-1.667H16.5V16a1.679 1.679 0 0 1 1.667-1.666A1.67 1.67 0 0 1 19.833 16v1.667H21.5c.918.006 1.66.749 1.667 1.666A1.671 1.671 0 0 1 21.5 21Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 32.667a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M33.167 29.334a3.333 3.333 0 1 0 3.333 3.333 3.324 3.324 0 0 0-3.333-3.334Z",
  clipRule: "evenodd"
}));
export default EmergencyResponseUnitIcon;